import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@libs/shared/auth';

@Component({
  selector: 'ui-logout',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class LogoutComponent implements OnInit {
  private readonly auth: AuthService = inject(AuthService);

  public ngOnInit(): void {
    void firstValueFrom(this.auth.logout());
  }
}
